import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export interface Transfer {
  block_time: string;
  from_entity: string;
  icon: string;
  symbol: string;
  to_entity: string;
  transaction_hash: string;
  value: number;
  value_usd: number;
}

const fetchTransfers = async (): Promise<Transfer[]> => {
  const response = await axios.get("https://feed-api.llama.fi/transfers");
  return response.data;
};

export const useTransfers = () => {
  return useQuery({
    queryKey: ["transfers"],
    queryFn: fetchTransfers,
    refetchInterval: 30000, // Refetch every 30 seconds
  });
};
